import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Restore SPA route after static 404 fallback
const redirect = sessionStorage.getItem('spaRedirect');
if (redirect && redirect !== window.location.pathname + window.location.search + window.location.hash) {
  window.history.replaceState(null, '', redirect);
  sessionStorage.removeItem('spaRedirect');
}

// Cache-busting hint: append build timestamp to a meta tag so hosting/CDN can vary cache
const meta = document.createElement('meta');
meta.name = 'build-id';
meta.content = String(Date.now());
document.head.appendChild(meta);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
